import IndexHtml from "static/time_listener/index_html";

const routes = [
    {
            name: "HTML",
            collapse: [
              {
                name: "index.html",
                route: "/index.html",
                component: IndexHtml,
              },
             
            ],
        },

        

]

export default routes;